<template>
  <section id="hero">
    <v-img
      :height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-6">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading title="국제 특송 운송&해외 구매대행 종합 솔루션" />

          <base-body>
            중국 구매대행 수집및 운송 전문 업체 엘티엘입니다. 
            엘티엘은 타오바오, 티몰 에서 판매되고 있는 제품을 국내에 있는 쿠팡 11번가, 위메프 등의 오픈 마켓에 동시에 업로드 해드리고 저렴하고 안전하게 빠른 배송까지 해드리는 한중 구매대행 전문업체입니다.
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <!--<base-btn>-->
              <!--Discover More-->
            <!--</base-btn>-->

            <!--<span class="font-weight-bold ml-6 mr-4 my-4">or</span>-->

            <base-btn
              :ripple="false"
              class="pa-1"
              target="_blank"
              href="https://erp.ltl.kr"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true }
    },

    computed: {
      minHeight() {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
